import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Text, Select, NestedField } from 'react-form';
import { isValidNumber } from 'libphonenumber-js';
import swal from 'sweetalert2';
import { modifierCoordonnes, modifierGestionnaire, obtenirProprietaire } from '../../App_Code/API';
import { estVide, estEmailValide, estEnCoursDeChargement } from '../../App_Code/Utils';
import NatContact, { NatTab } from '../../App_Data/NatContact';
import * as ProAct from '../../Actions/ProActions';
import * as HttpStatus from '../../App_Data/HttpStatus';
import Card from '../Card';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import { AfficherFeedback, Texte, Liste } from '../ChampFormulaire';

let SelectNatures = [];

const Champs = [
    // { Nom: 'Civilite', Obligatoire: true },
    // { Nom: 'Nom', Obligatoire: true },
    { Nom: 'Ad1', Obligatoire: true },
    { Nom: 'Ad2', Obligatoire: false },
    { Nom: 'Cp', Obligatoire: true },
    { Nom: 'Ville', Obligatoire: true },
    { Nom: 'Pays', Obligatoire: true },
];

const MAX_CONTACTS = 8;

const LigneContact = ({ Ind, refRef, formApi }) => (
    <div className="form-row">
        <Text field="Id" id={`contact-Id-${Ind}`} placeholder="Id" className="form-control" hidden />
        <div className="form-group col-md-3">
            <Select
                field="Nat"
                id={`contact-nat-${Ind}`}
                options={SelectNatures}
                placeholder="Nature du contact"
                className="form-control"
            />
        </div>
        <div className="form-group col-md-4">
            <Text field="Libelle" id={`contact-libelle-${Ind}`} placeholder="Libellé" className="form-control" maxLength={30} />
        </div>
        <div className="form-group col-md-4">
            {formApi.getFormState().values.contacts[Ind].Nat === 4 ? (
                <Texte field="Ref" id={`contact-ref-${Ind}`} placeholder="Courriel" type="email" refRef={refRef} maxLength={50} />
            ) : (
                <Texte field="Ref" id={`contact-ref-${Ind}`} placeholder="Numéro" type="tel" refRef={refRef} maxLength={50} />
            )}
            <div className="invalid-feedback">Ce champ n&apos;est pas valide</div>
        </div>
        <div className="form-group col-md-1">
            <button onClick={() => formApi.removeValue('contacts', Ind)} type="button" className="btn btn-danger">
                <i className="fas fa-times" />
            </button>
        </div>
    </div>
);

const LigneECourrier = ({
    titre, valeur,
}) => (
    <div className={`row mb-2`} style={{alignItems:"center"}}>
        <span className={`col-1`}></span>
        <span className={`col-3 text-secondary`}>{titre}</span>
        <span className={`col-7`}>{valeur}</span>
    </div>
);

const FormulaireAdresse = ({
    inputs, ModifGest, Civilites, Pays,
}) => (
    <Card Titre={ModifGest ? 'Adresse du gestionnaire' : "Changement d'adresse"}>
        <NestedField field="Adresse">
            <div className="form-row">
                <div className="form-group col-md-3 optionnal">
                    <label htmlFor="Civilite">Civilité</label>
                    <Liste
                        field="Civilite"
                        id="Civilite"
                        options={Civilites}
                        placeholder="Civilité"
                        className="form-control"
                        refRef={inputs.Civilite}
                        readOnly
                        disabled
                    />
                </div>
                <div className="form-group col-md-9 optionnal">
                    <label htmlFor="Nom">Nom</label>
                    <Texte field="Nom" id="Nom" placeholder="Nom et prénom" type="text" refRef={inputs.Nom} maxLength={50} readOnly />
                </div>
            </div>
            <div className="form-group required">
                <label htmlFor="Ad1">Adresse</label>
                <Texte field="Ad1" id="Ad1" placeholder="Adresse" type="text" refRef={inputs.Ad1} maxLength={50} />
                <div className="invalid-feedback">Veuillez renseigner votre adresse</div>
            </div>
            <div className="form-group optionnal">
                <label htmlFor="Ad2">Complément</label>
                <Texte field="Ad2" id="Ad2" placeholder="Complément" type="text" refRef={inputs.Ad2} maxLength={50} />
            </div>
            <div className="form-row">
                <div className="form-group col-md-2 required">
                    <label htmlFor="Cp">Code postal</label>
                    <Texte field="Cp" id="Cp" placeholder="Code postal" type="text" refRef={inputs.Cp} maxLength={10} />
                    <div className="invalid-feedback">Veuillez renseigner un code postal valide</div>
                </div>
                <div className="form-group col-md-6 required">
                    <label htmlFor="Ville">Ville</label>
                    <Texte field="Ville" id="Ville" placeholder="Ville" type="text" refRef={inputs.Ville} maxLength={50} />
                    <div className="invalid-feedback">Veuillez renseigner votre ville</div>
                </div>
                <div className="form-group col-md-4 required">
                    <label htmlFor="Pays">Pays</label>
                    <Liste
                        field="Pays"
                        id="Pays"
                        options={Pays}
                        placeholder="Pays"
                        className="form-control"
                        refRef={inputs.Pays}
                    />
                    <div className="invalid-feedback">Veuillez renseigner votre pays</div>
                </div>
            </div>
        </NestedField>
    </Card>
);

const FormulaireContact = ({ inputs, ModifGest, formApi, Ecourrier }) => {
    const lsContacts =
        formApi.values.contacts &&
        formApi.values.contacts.map((contact, i) => (
            <NestedField
                key={i}
                field={['contacts', i]}
                render={() => <LigneContact Ind={i} refRef={inputs[i]} formApi={formApi} />}
            />
        ));

    const lsEcourrier =
       !Ecourrier.Email && !Ecourrier.Tel ? null : (
            <React.Fragment>
                <div className="row mb-2"><span className={`col-12 text-secondary`}>&nbsp;</span></div>
                <div className="row mb-2">
                    <span className={`col-11`}>Courrier électronique</span>
                    <span className={`col-md-1`}>
                        <Link to={{ pathname: '/MesInformations/Ecourrier', state: { Reinscirption: true } }} className="btn btn-outline-orange" title='Le courrier électronique nécessite une procédure séparée de validation des coordonnées'>
                        <i class="fas fa-pen"></i>
                        </Link>
                    </span>
                </div>
                <LigneECourrier titre={'Adresse e-mail :'} valeur={Ecourrier.Email} />
                <LigneECourrier titre={'n° pour SMS :'} valeur={Ecourrier.Tel} />
            </React.Fragment>
       );
    
    const boutonAjout =
        !formApi.values.contacts || formApi.values.contacts.length >= MAX_CONTACTS ? null : (
            <div className="text-center">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => formApi.addValue('contacts', {
                        Id: 0, Nat: 1, Libelle: '', Ref: '',
                    })}
                >
                    Ajouter un contact
                </button>
            </div>
        );

    return (
        <Card
            Titre={ModifGest ? 'Contacts du gestionnaire' : 'Changement de contacts'}
            Info="Vous ne pouvez avoir qu&apos;un seul contact par nature. Celui gardé par défaut sera toujours le dernier ajouté, sauf si vous le supprimez. Par contre, si vous modifiez votre adresse email, cela ne changera pas celle de connexion, ni celle des courriers electroniques qui se font par une procédure séparée avec validation."
        >
            {lsContacts}
            {boutonAjout}
            {lsEcourrier}
        </Card>
    );
};



class PageCoordonnees extends Component {
    constructor(props) {
        super(props);

        /* Le slice retire la nature Site web de la liste */
        SelectNatures = NatTab.slice(0, 4).map(nature => ({
            label: nature.lib,
            value: nature.Ind,
        }));

        this.boutonEnvoyer = React.createRef();
        this.inputs = {};
        Champs.forEach((champ) => {
            this.inputs = { ...this.inputs, [champ.Nom]: React.createRef() };
        });

        this.inputsContact = [];
        for (let i = 0; i < MAX_CONTACTS; i += 1) {
            this.inputsContact[i] = React.createRef();
        }

        this.ModifGestionnaire = props.location.pathname.includes('/Gestionnaire');
        const Qui = this.ModifGestionnaire ? props.Gestionnaire : props.Ind;
        if (Qui === null) {
            this.defaultValues = {
                Adresse: {
                    Civilite: '',
                    Nom: '',
                    Ad1: '',
                    Ad2: '',
                    Cp: '',
                    Ville: '',
                    Pays: '',
                },
                contacts: [],
            };
        } else {
            const {
                Civilite, Nom, Adresse, LsContacts,
            } = Qui;

            this.defaultValues = {
                Adresse: {
                    Civilite,
                    Nom,
                    Ad1: Adresse ? Adresse.Ad1 : '',
                    Ad2: Adresse ? Adresse.Ad2 : '',
                    Cp: Adresse ? Adresse.Cp : '',
                    Ville: Adresse ? Adresse.Ville : '',
                    Pays: Adresse ? Adresse.Pays : '',
                },
                contacts: LsContacts || [],
            };

            this.selectedPays = this.defaultValues.Adresse.Pays;
        }
    }

    componentWillUnmount() {
        if (this.unblock) this.unblock();
    }

    handleChange = () => {
        if (!this.unblock) {
            const mess = this.props.ModifCoordOk && !this.props.location.pathname.includes('/Gestionnaire')
                ? 'ne les avez pas enregistrées.'
                : "n'avez pas envoyé la demande au syndic.";

            this.unblock = this.props.history.block(`Vous avez effectué des modifications, mais vous ${mess} <br><strong>Voulez-vous vraiment quitter cette page ?</strong>`);
        }
    };

    handleSubmit = (submittedValues) => {
        let selectedPays = this.selectedPays;
        let cpValide = true;
        const { Adresse, contacts } = this.defaultValues;
        const ChangementsAdresse = [];
        const ChangementsContact = [];
        let formChangements = false;
        let formValide = true;
        this.boutonEnvoyer.current.disabled = true;

        Champs.forEach((champ) => {
            const valeur = submittedValues.Adresse[champ.Nom];
            const changement = Adresse[champ.Nom] !== valeur;
            const valide = !champ.Obligatoire || !estVide(valeur);

            if (this.inputs[champ.Nom].current !== null) {
                AfficherFeedback(this.inputs[champ.Nom], valide);
            }

            if (changement) {
                if (champ.Nom === 'Pays') {
                    selectedPays = valeur;
                }
                ChangementsAdresse.push({
                    Libelle: champ.Nom,
                    Ancienne: Adresse[champ.Nom],
                    Nouvelle: valeur,
                });
            }

            formChangements = formChangements || changement;
            formValide = formValide && valide;
        });

        // verfication du code postal
        ChangementsAdresse.forEach(((champ) => {
            if (champ.Libelle === 'Cp') {
                if (selectedPays === 'FR' && champ.Nouvelle.length !== 5) {
                    AfficherFeedback(this.inputs[champ.Libelle], false);
                    cpValide = false;
                }
            }
        }));

        if (!cpValide) {
            this.boutonEnvoyer.current.disabled = false;
            return;
        }

        submittedValues.contacts.forEach((contact, i) => {
            const estNouveau = i >= contacts.length;
            const changementRef = estNouveau || contacts[i].Ref !== contact.Ref;
            const changement =
                changementRef ||
                !contacts[i] ||
                contacts[i].Nat !== contact.Nat ||
                contacts[i].Libelle !== contact.Libelle;
            const valide =
                contact.Nat === 4
                    ? estEmailValide(contact.Ref)
                    : isValidNumber(contact.Ref, 'FR') ||
                      isValidNumber(contact.Ref, Adresse.Pays) ||
                      isValidNumber(contact.Ref);

            AfficherFeedback(this.inputsContact[i], valide);

            if (changement) {
                ChangementsContact.push({
                    Ancienne: estNouveau ? null : { ...contacts[i], NatLib: NatContact(contacts[i].Nat).lib },
                    Nouvelle: { ...contact, NatLib: NatContact(contact.Nat).lib },
                });
            }

            formChangements = formChangements || changement;
            formValide = formValide && valide;
        });

        if (submittedValues.contacts.length < contacts.length) {
            const LsSuppressions = contacts.filter((contact1) => {
                const res = ChangementsContact.find(contact2 =>
                    contact1.Id === contact2.Ancienne.Id);
                return res === undefined;
            });

            LsSuppressions.forEach((contact) => {
                ChangementsContact.push({
                    Ancienne: { ...contact, NatLib: NatContact(contact.Nat).lib },
                    Nouvelle: null,
                });
            });

            formChangements = true;
        }

        if (!formChangements && this.unblock) this.unblock();
        if (!formChangements || !formValide) {
            this.boutonEnvoyer.current.disabled = false;
            return;
        }

        if (this.ModifGestionnaire) {
            modifierGestionnaire(ChangementsAdresse, ChangementsContact).then((response) => {
                if (response.status === HttpStatus.OK) {
                    swal('Succès', 'La demande de modification du gestionnaire à été envoyé au syndic.', 'success');
                    if (this.unblock) this.unblock();
                    this.props.history.push('/MesInformations');
                } else {
                    const footer =
                        response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                    swal({
                        type: 'error',
                        title: 'Erreur',
                        text: "Une erreur s'est produite lors de la demande de modification du gestionnaire.",
                        footer,
                    });
                    this.boutonEnvoyer.current.disabled = false;
                }
            });
        } else {
            modifierCoordonnes(this.props.ModifCoordOk, ChangementsAdresse, ChangementsContact).then((response) => {
                if (response.status === HttpStatus.OK) {
                    const mess = this.props.ModifCoordOk ? 'Le changement de coordonnées a bien été prise en compte.' : 'La demande de changement de coordonnées a été envoyée au syndic.';
                    swal('Succès', mess, 'success');
                    if (this.unblock) this.unblock();
                    if (this.props.ModifCoordOk) {
                        obtenirProprietaire().then((pro) => {
                            this.props.actions.proAjout(pro);
                        });
                    }
                    this.props.history.push('/MesInformations');
                } else {
                    const mess = this.props.ModifCoordOk ? "Une erreur s'est produite lors de l'enregistrement des nouvelles coordonées." : "Une erreur s'est produite lors de la demande de changement de coordonnées.";
                    const footer =
                        response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : '';
                    swal({
                        type: 'error',
                        title: 'Erreur',
                        text: mess,
                        footer,
                    });
                    this.boutonEnvoyer.current.disabled = false;
                }
            });
        }
    };

    render() {
        const { Civilites, Pays, Ecourrier } = this.props;
        if (estEnCoursDeChargement(Civilites) || estEnCoursDeChargement(Pays)) return <Chargement />;

        return (
            <Form defaultValues={this.defaultValues} onChange={this.handleChange} onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6">
                                <FormulaireAdresse
                                    inputs={this.inputs}
                                    ModifGest={this.ModifGestionnaire}
                                    Civilites={Civilites}
                                    Pays={Pays}
                                    setVerifCP={this.setVerifCP}
                                />
                            </div>
                            <div className="col-sm-12 col-lg-6">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <FormulaireContact
                                            inputs={this.inputsContact}
                                            ModifGest={this.ModifGestionnaire}
                                            formApi={formApi}
                                            Ecourrier={Ecourrier}
                                        />
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-xl-12">
                                        <CardEcourrierInfos />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-center">
                                <button type="submit" className="btn btn-lg btn-success" ref={this.boutonEnvoyer}>
                                    { this.props.ModifCoordOk && !this.ModifGestionnaire ? 'Valider mes changements' : 'Envoyer la demande au syndic' }
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Form>
        );
    }
}
PageCoordonnees.displayName = 'PageCoordonnees';
PageCoordonnees.requiredProps = [
    'Ind', // Informations sur le propriétaire
    // 'Gestionnaire', // Informations sur le gestionnaire
    'Civilites', // Liste des civilités
    'Pays', // Liste des pays
];

function mapStateToProps({
    ProStore: {
        Pro: { Ind, Gestionnaire, Ecourrier },
        Civilites,
        Pays,
    },
    SynStore: {
        Syn: {
            ModifCoordOk,
        },
    },
}) {
    return {
        Ind,
        Gestionnaire,
        Ecourrier,
        Civilites,
        Pays,
        ModifCoordOk,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}
export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageCoordonnees));



// WEBPACK FOOTER //
// ./src/components/MesInfos/PageCoordonnees.js